"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var ORGANISATIONSNUMMER_REGEXP = /^([0-9]{6})-?([0-9]{4})$/;
exports.organisationsnummerValidator = {
    name: 'organisationsnummer',
    formatter: function (value) {
        if (ORGANISATIONSNUMMER_REGEXP.test(value) && value.length === 10) {
            return value.substring(0, 6) + "-" + value.substring(6, 10);
        }
        return value;
    },
    validation: function (value) {
        if (utils_1.isEmpty(value)) {
            return true;
        }
        if (ORGANISATIONSNUMMER_REGEXP.test(value) && utils_1.testLuhnChecksum(value.replace(/-/g, ''))) {
            return true;
        }
        return false;
    },
};
//# sourceMappingURL=OrganisationsnummerValidator.js.map